// src/components/private/dashboard/Dashboards.js
// This is the Dashboards component which is a container for all the dashboard components

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HighgardenDash from './HighgardenDash';

function Dashboards() {
    // eslint-disable-next-line no-lone-blocks
    {/*
    const [key, setKey] = useState('theFingers');
    const [tier, setTier] = useState('');

    useEffect(() => {
        const userInfoContent = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfoContent) {
            setTier(userInfoContent.tier_slug);
        }
    }, []);
    */}

    return (
        <Container fluid style={{ padding: '0' }}>
            <Row>
                <Col>
                    {/*
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-2"
                    >
                         For business reasons, we are hiding these modules for now; when ready to be used, please import them at the top as well
                        <Tab eventKey="theFingers" title="Expenses and Budgets">
                            <div>
                                <TheFingersDash />
                            </div>
                        </Tab>
                        <Tab eventKey="passivity" title="Finances">
                            <div>
                                <PassivityDash />
                            </div>
                        </Tab>
                        
                        {tier === 'complete' && (
                            <Tab eventKey="highgarden" title="Grocery">
                                <div>
                                    <HighgardenDash />
                                </div>
                            </Tab>
                        )}
                    </Tabs>
                    */}
                    <HighgardenDash />
                </Col>
            </Row>
        </Container>
    );
}

export default Dashboards;